export const moduleName = 'qrCodes'

export type QrCodeAppearance = {
  dotColour: string
  cornerSquareColour: string
  cornerDotColour: string
  backgroundColour: string | 'transparent'
  imgUrl: string | undefined
}

export type QrCodesState = {
  url: string
  appearance: QrCodeAppearance
  filename: string
  blobUrl: string | null
  blob: Blob | null
}
